module.exports = __webpack_public_path__ + "img/builds.de5958d8.jpg";